document.addEventListener("turbo:load", function () {
  document.querySelectorAll(".item-fields").forEach((wrapper) => {
    const itemSelect = wrapper.querySelector("select[name*='[item_id]']");
    const rateTypeSelect = wrapper.querySelector(".seller-rate-type-select");
    const rateTypeContainer = rateTypeSelect?.closest(".input-group");

    function toggleRateTypeVisibility() {
      if (!itemSelect || !rateTypeSelect || !rateTypeContainer) return;

      const selectedText = itemSelect.options[itemSelect.selectedIndex]?.text?.trim()?.toUpperCase() || "";
      if (selectedText === "SOYA CRUDE OIL") {
        rateTypeSelect.style.display = "block";
        rateTypeContainer.style.display = "flex";
      } else {
        rateTypeSelect.value = "";
        rateTypeSelect.style.display = "none";
        rateTypeContainer.style.display = "";
      }
    }

    toggleRateTypeVisibility();
    itemSelect?.addEventListener("change", toggleRateTypeVisibility);
  });

  function toggleFinancerRate() {
    const financerSelect = document.getElementById("financer-select");
    const financerRateFields = document.querySelectorAll(".item-fields .financer-rate-field");

    financerRateFields.forEach((field) => {
      const financerRateInput = field.querySelector(".form-control");
      const fieldWrapper = financerRateInput?.closest(".col-lg-2");
      if (fieldWrapper) {
        fieldWrapper.style.display = financerSelect.value ? "block" : "none";
      }
    });
  }

  const financerSelect = document.getElementById("financer-select");
  if (financerSelect) {
    financerSelect.addEventListener("change", toggleFinancerRate);
    toggleFinancerRate();
  }

  document.querySelectorAll(".item-fields").forEach((wrapper) => {
    const gstSelect = wrapper.querySelector(".gst-condition-select");
    const gstFieldWrapper = wrapper.querySelector(".gst-fields");
    const gstInput = wrapper.querySelector(".gst-percentage-field");
    const gstResult = wrapper.querySelector(".gst-calculated-text");
    const gstRateText = wrapper.querySelector(".gst-seller-rate");
    const sellerRateInput = wrapper.querySelector('[name*="[seller_rate]"]');
    const financerRateInput = wrapper.querySelector('[name*="[financer_rate]"]');
    const financerGstRateText = wrapper.querySelector(".gst-financer-rate");
    const gstFinancerResult = wrapper.querySelector(".show-financer-gst-rate");

    const forCheckbox = wrapper.querySelector("#is_freight_on_road_checkbox");
    const freightCheckbox = wrapper.querySelector("#is_for_applicable_checkbox");

    const forField = forCheckbox?.closest(".col-md-6");
    const freightField = freightCheckbox?.closest(".col-md-6");

    const freightPaidByField = wrapper.querySelector("#freight_paid_by_field");
    const freightPaidByInput = freightPaidByField?.querySelector("input");

    const mandiCheckbox = wrapper.querySelector('[name*="[is_mandi_applicable]"]');
    const mandiField = mandiCheckbox?.closest(".mandi-fields");
    const mandiPaidByField = wrapper.querySelector(".mandi-paid-by-field");
    const mandiPaidByInput = mandiPaidByField?.querySelector("input");

    function syncCheckboxHiddenField(checkbox) {
      if (!checkbox) return;
      const name = checkbox.name;
      const hidden = wrapper.querySelector(`input[type="hidden"][name="${name}"]`);
      if (checkbox.checked) {
        hidden?.remove();
      } else {
        if (!hidden) {
          const newHidden = document.createElement("input");
          newHidden.type = "hidden";
          newHidden.name = name;
          newHidden.value = "false";
          checkbox.parentNode.appendChild(newHidden);
        }
      }
    }

    function resetField(field) {
      if (!field) return;
      const input = field.querySelector("input, select, textarea");
      if (input?.type === "checkbox") {
        input.checked = false;
        syncCheckboxHiddenField(input);
      } else if (input) {
        input.value = "";
      }
      field.style.display = "none";
    }

    function enforceMutualExclusivity(triggeredBy) {
      if (!forCheckbox || !freightCheckbox) return;

      if (triggeredBy === "freight" && freightCheckbox.checked) {
        forCheckbox.checked = false;
        syncCheckboxHiddenField(forCheckbox);
      } else if (triggeredBy === "for" && forCheckbox.checked) {
        freightCheckbox.checked = false;
        syncCheckboxHiddenField(freightCheckbox);
        resetField(freightPaidByField);
      }
    }

    function toggleFreightPaidByField() {
      if (freightCheckbox?.checked) {
        freightPaidByField.style.display = "block";
      } else {
        freightPaidByField.style.display = "none";
        if (freightPaidByInput) freightPaidByInput.value = "";
      }
    }

    function toggleMandiPaidByField() {
      if (mandiCheckbox?.checked) {
        mandiPaidByField.style.display = "block";
      } else {
        mandiPaidByField.style.display = "none";
        if (mandiPaidByInput) mandiPaidByInput.value = "";
      }
    }

    function calculateGstRate() {
      const baseRate = parseFloat(sellerRateInput?.value) || 0;
      const baseFinancerRate = parseFloat(financerRateInput?.value) || 0;
      const gstPercent = parseFloat(gstInput?.value) || 0;

      const total = baseRate + (baseRate * gstPercent / 100);
      const financerTotal = baseFinancerRate + (baseFinancerRate * gstPercent / 100);

      gstRateText.textContent = `${total.toFixed(2)}`;
      if (baseFinancerRate) {
        financerGstRateText.textContent = `${financerTotal.toFixed(2)}`;
        gstFinancerResult.style.display = "block";
      } else {
        gstFinancerResult.style.display = "none";
      }

      gstResult.style.display = "block";
    }

    function toggleGstFieldVisibility() {
      const gstVal = gstSelect.value?.trim();
      gstFieldWrapper.style.display = "none";
      gstResult.style.display = "none";
    
      if (gstVal === "with_gst") {
        gstFieldWrapper.style.display = "block";
        if (sellerRateInput?.value && gstInput?.value) calculateGstRate();
        if (forField) forField.style.display = "block";
        if (freightField) freightField.style.display = "block";
        toggleFreightPaidByField();
      } else if (gstVal === "none_gst") {
        if (mandiField) mandiField.style.display = "block";
        toggleMandiPaidByField();
    
        if (forField) forField.style.display = "none";
        if (freightField) freightField.style.display = "none";
        if (freightPaidByField) freightPaidByField.style.display = "none";
        if (gstInput) gstInput.value = "";
      } else if (gstVal === "including_all") {
        if (forField) forField.style.display = "none";
        if (freightField) freightField.style.display = "none";
        if (freightPaidByField) freightPaidByField.style.display = "none";
        if (gstInput) gstInput.value = "";
        if (mandiField) mandiField.style.display = "none";
        if (mandiPaidByField) mandiPaidByField.style.display = "none";
      } else {
        if (mandiField) mandiField.style.display = "none";
        if (mandiPaidByField) mandiPaidByField.style.display = "none";
    
        if (forField) forField.style.display = "block";
        if (freightField) freightField.style.display = "block";
        toggleFreightPaidByField();
      }
    }

    forCheckbox?.addEventListener("change", () => {
      enforceMutualExclusivity("for");
      syncCheckboxHiddenField(forCheckbox);
    });

    freightCheckbox?.addEventListener("change", () => {
      enforceMutualExclusivity("freight");
      toggleFreightPaidByField();
      syncCheckboxHiddenField(freightCheckbox);
    });

    mandiCheckbox?.addEventListener("change", () => {
      toggleMandiPaidByField();
      syncCheckboxHiddenField(mandiCheckbox);
    });

    gstSelect?.addEventListener("change", toggleGstFieldVisibility);
    gstInput?.addEventListener("input", calculateGstRate);
    sellerRateInput?.addEventListener("input", () => {
      if (gstSelect.value === "with_gst") calculateGstRate();
    });
    financerRateInput?.addEventListener("input", () => {
      if (gstSelect.value === "with_gst") calculateGstRate();
    });

    syncCheckboxHiddenField(forCheckbox);
    syncCheckboxHiddenField(freightCheckbox);
    syncCheckboxHiddenField(mandiCheckbox);
    toggleGstFieldVisibility();
    toggleMandiPaidByField();
    if (forCheckbox?.checked && freightCheckbox?.checked) {
      freightCheckbox.checked = false;
      syncCheckboxHiddenField(freightCheckbox);
    }
  });

  const weightInput = document.getElementById("weight-input");
  if (weightInput) {
    weightInput.addEventListener("input", function () {
      const value = weightInput.value.trim();
      const regex = /^(\d+(\.\d+)?|\d+(\.\d+)?-\d+(\.\d+)?)$/;
      if (value === "") {
        weightInput.setCustomValidity("");
      } else if (!regex.test(value)) {
        weightInput.setCustomValidity("Please enter a valid quantity or a range like 10-20.");
      } else {
        const parts = value.split("-");
        if (parts.length === 2 && parseFloat(parts[0]) > parseFloat(parts[1])) {
          weightInput.setCustomValidity("Start quantity must be less than or equal to end quantity.");
        } else {
          weightInput.setCustomValidity("");
        }
      }
    });
  }
});
